module.exports = __webpack_public_path__ + "img/title-1.4a229def.png";